<template>
  <label :for="`select-experiment-input-${parent}-${field.name}`">
    {{ field.label ? field.label : field.name }}
  </label>
  <select
    :id="`select-experiment-input-${parent}-${field.name}`"
    :value="modelValue"
    class="select"
    :disabled="!projectId"
    @input="$emit('update:modelValue', parseInt($event.target.value, 10))"
  >
    <option :value="null" disabled selected>Select Experiment</option>
    <option
      v-for="(experiment, i) in experiments"
      :key="`dropdown-${parent}-${field.name}-${i}-${experiment.id}`"
      :value="experiment.id"
    >
      {{ experiment.name }}
    </option>
  </select>
</template>

<script setup>
import {
  ref, onMounted, watch,
} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

const props = defineProps({
  parent: {
    type: String,
    default: 'profiler-val-session',
  },
  field: {
    type: Object,
    default: () => ({ name: 'experiment', label: 'Experiment' }),
  },
  modelValue: {
    type: Number,
    default: null,
  },
  projectId: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['update:modelValue']);
const experiments = ref([]);

async function getExperiments(projectId) {
  if (!projectId) {
    experiments.value = [];
    emit('update:modelValue', null);
    return;
  }

  try {
    const dataConnect = new DatastoreConnect();
    const response = await dataConnect.api('experiment.list', {
      project_id: parseInt(projectId, 10),
    });

    if (response.error) {
      throw response.error;
    }

    experiments.value = response.result || [];

    if (!experiments.value.some((e) => e.id === props.modelValue)) {
      emit('update:modelValue', experiments.value[0]?.id || null);
    }
  } catch (error) {
    console.error('Error fetching experiments:', error);
    experiments.value = [];
    emit('update:modelValue', null);
  }
}

watch(() => props.projectId, async (newProjectId) => {
  await getExperiments(newProjectId);
}, { immediate: true });

onMounted(async () => {
  await getExperiments(props.projectId);
});
</script>
